export default __webpack_public_path__ + "static/media/social-facebook.74de343a.svg";